import { render, staticRenderFns } from "./PremiumInformation.vue?vue&type=template&id=2210c11c&scoped=true"
import script from "./PremiumInformation.vue?vue&type=script&lang=ts"
export * from "./PremiumInformation.vue?vue&type=script&lang=ts"
import style0 from "./PremiumInformation.vue?vue&type=style&index=0&id=2210c11c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2210c11c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2210c11c')) {
      api.createRecord('2210c11c', component.options)
    } else {
      api.reload('2210c11c', component.options)
    }
    module.hot.accept("./PremiumInformation.vue?vue&type=template&id=2210c11c&scoped=true", function () {
      api.rerender('2210c11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/PremiumInformation.vue"
export default component.exports